// extracted by mini-css-extract-plugin
export default {"containerClassName":"src-pages-SalesCannelVersion-SalesChannelSettings-SalesChannelCheckout-SectionWrapper-css-module__containerClassName--4+aeG"};